"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpointRuleMatch = useBreakpointRuleMatch;

var _useMediaQuery = require("@ui-kit.next/core/hooks/useMediaQuery");

function useBreakpointRuleMatch(breakpoint, queryGenerator) {
  return (0, _useMediaQuery.useMediaQuery)(queryGenerator(breakpoint)).matches;
}